import React from 'react';
import "../../../styles/TableStyles.css";

const UserLeaves = () => {
  return (
    <div className='table-responsive'>
      <h2>User Leave Balances</h2>
      <p>Track remaining leave balances for each user.</p>
      <table className="table">
        <thead>
          <tr>
            <th>User</th>
            <th>Annual Leave</th>
            <th>Sick Leave</th>
            <th>Casual Leave</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>John Doe</td>
            <td>5</td>
            <td>2</td>
            <td>3</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UserLeaves;